////////////////////////////////////////////////////////////////////////////////
//                                                                            //
//  IRONSIDE - Public Website GUI                                             //
//                                                                            //
//  Version: 1.0.5                                                            //
//  Summary: Sidekick gate — public-config probe + lazy chunk load; renders   //
//           nothing (and loads nothing) when the bot flag is off             //
//                                                                            //
////////////////////////////////////////////////////////////////////////////////

import { lazy, Suspense, useEffect, useState } from 'react';

import api from '@/lib/api';

// The widget proper is its own chunk (mirrors the admin lazy-split discipline,
// 1.0.5.md §2.3) — the public entry pays only for this gate.
const SideKick = lazy(() => import('./SideKick'));

interface PublicConfigResponse {
  bot?: {
    enabled?: boolean;
    name?: string;
    turnstile?: { site_key?: string | null };
  };
}

interface BotClientConfig {
  name: string;
  siteKey: string | null;
}

export function SideKickMount () {
  const [bot, setBot] = useState<BotClientConfig | null>(null);

  useEffect(() => {
    let cancelled = false;
    api.get<PublicConfigResponse>('/public/config')
      .then(({ data }) => {
        if (cancelled || !data.bot?.enabled) return;
        setBot({
          name: data.bot.name ?? 'Sidekick',
          siteKey: data.bot.turnstile?.site_key ?? null,
        });
      })
      // Probe failure (404 flag-off, endpoint absent, network) → self-hide.
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  if (!bot) return null;
  return (
    <Suspense fallback={null}>
      <SideKick name={bot.name} siteKey={bot.siteKey} />
    </Suspense>
  );
}
